import React from 'react';

const Rating = ({ value, text, color = 'text-yellow-400' }) => {
  return (
    <div className="flex items-center">
      <div className="flex mr-1">
        <span>
          <i
            className={
              value >= 1
                ? `fas fa-star ${color}`
                : value >= 0.5
                ? `fas fa-star-half-alt ${color}`
                : `far fa-star ${color}`
            }
          ></i>
        </span>
        <span>
          <i
            className={
              value >= 2
                ? `fas fa-star ${color}`
                : value >= 1.5
                ? `fas fa-star-half-alt ${color}`
                : `far fa-star ${color}`
            }
          ></i>
        </span>
        <span>
          <i
            className={
              value >= 3
                ? `fas fa-star ${color}`
                : value >= 2.5
                ? `fas fa-star-half-alt ${color}`
                : `far fa-star ${color}`
            }
          ></i>
        </span>
        <span>
          <i
            className={
              value >= 4
                ? `fas fa-star ${color}`
                : value >= 3.5
                ? `fas fa-star-half-alt ${color}`
                : `far fa-star ${color}`
            }
          ></i>
        </span>
        <span>
          <i
            className={
              value >= 5
                ? `fas fa-star ${color}`
                : value >= 4.5
                ? `fas fa-star-half-alt ${color}`
                : `far fa-star ${color}`
            }
          ></i>
        </span>
      </div>
      <span className="text-sm text-gray-500">{text && text}</span>
    </div>
  );
};

export default Rating;
